import { Card, Grid } from '@mui/material'

import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import PageUrls from '../../../../../../constants/page-urls'
import LeadImportForm from './components/LeadImportForm'

const Menus = [
  {
    breadcrumbName: 'รายการติดตามทั้งหมด',
    title: 'รายการติดตามทั้งหมด',
    path: PageUrls.CRM.Lead.List,
  },
]

const LeadImportPage = () => {
  return (
    <ContentWrapper>
      <Helmet title="นำเข้า Lead จากคำสั่งซื้อ" />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="นำเข้า Lead จากคำสั่งซื้อ"
            routes={Menus}
            descriptions="นำเข้า Lead จากคำสั่งซื้อ"
          />
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        <LeadImportForm />
      </Card>
    </ContentWrapper>
  )
}

export default LeadImportPage
